export default "__VITE_ASSET__Bnw3_8cH__"